import { render } from "./voucher.vue?vue&type=template&id=a18ef962&scoped=true&ts=true"
import script from "./voucher.vue?vue&type=script&lang=ts"
export * from "./voucher.vue?vue&type=script&lang=ts"

import "./voucher.vue?vue&type=style&index=0&id=a18ef962&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a18ef962"]])

export default __exports__